var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.5H26.168L34.375 11.707V34.875C34.375 35.7676 33.6426 36.5 32.75 36.5H11.5C10.6074 36.5 9.875 35.7676 9.875 34.875V5.125C9.875 4.23239 10.6074 3.5 11.5 3.5Z",
    fill: "#F3F4F6",
    stroke: "#0E9F6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 14H35L34 11.5L26 3V11.25C26 13.5 26 14 28.25 14Z",
    fill: "#0E9F6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.625 30.625C30.625 31.2094 30.1469 31.6875 29.5625 31.6875H6.1875C5.60312 31.6875 5.125 31.2094 5.125 30.625V20C5.125 19.4156 5.60312 18.9375 6.1875 18.9375H29.5625C30.1469 18.9375 30.625 19.4156 30.625 20V30.625Z",
    fill: "#0E9F6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7186 24.6601L13.1976 22.8082C13.6385 22.2312 14.497 22.9697 14.0136 23.5222C13.5047 24.1257 12.9692 24.7802 12.4581 25.4495L14.1921 27.6075C14.6585 28.245 13.7246 28.857 13.2656 28.228L11.7027 26.223L10.1652 28.2705C9.73172 28.8899 8.77122 28.194 9.25678 27.616L10.9642 25.4495C10.4287 24.7791 9.91022 24.1257 9.39278 23.5222C8.85728 22.8847 9.85178 22.2312 10.2417 22.8262L11.7186 24.6601Z",
    fill: "#F3F4F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3651 24.7705V27.9133C16.3651 28.2884 16.0591 28.4998 15.7541 28.4998C15.4821 28.4998 15.2441 28.2884 15.2441 27.9133V23.131C15.2441 22.689 15.6192 22.5435 15.7541 22.5435C15.9996 22.5435 16.1441 22.689 16.2886 22.8505L18.1586 25.3729L20.0945 22.756C20.376 22.4085 21.0635 22.5435 21.0635 23.131V27.9133C21.0635 28.2884 20.8255 28.4998 20.5545 28.4998C20.2485 28.4998 20.0105 28.2884 20.0105 27.9133V24.7705L18.5995 26.5544C18.2946 26.9295 17.9121 26.9295 17.6316 26.5544L16.3651 24.7705Z",
    fill: "#F3F4F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.543 23.1313C22.543 22.8508 22.781 22.6128 23.0785 22.6128C23.3505 22.6128 23.58 22.8519 23.58 23.1313V27.3877H25.8909C26.7228 27.3877 26.7409 28.5001 25.8909 28.5001H23.0795C22.782 28.5001 22.544 28.2887 22.544 27.9816V23.1313H22.543Z",
    fill: "#F3F4F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXml);
export default __webpack_public_path__ + "static/media/xml.5c2c93ccab628cfd4f5f6708a619683a.svg";
export { ForwardRef as ReactComponent };